"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroMeta = HeroMeta;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/ui/heroMeta.tsx",
    _this2 = void 0;

function HeroMeta(_ref) {
  var _this = this;

  var items = _ref.items;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4,
      columnNumber: 13
    }
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(Group, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5,
        columnNumber: 33
      }
    }, /*#__PURE__*/_react["default"].createElement(Name, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6,
        columnNumber: 6
      }
    }, item.name), /*#__PURE__*/_react["default"].createElement(Value, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7,
        columnNumber: 6
      }
    }, item.value));
  }));
}

var Container = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      C = _ref2$as === void 0 ? "div" : _ref2$as,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 88
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "m123i0",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 92
    }
  }, [".cc-m123i0{display:flex;flex-wrap:wrap;justify-content:flex-end;border-top:1px solid #111;padding:8px;background-color:rgba(0,0,0,0.3)}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-m123i0" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 256
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Container.displayName = "Container";
}

var Group = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "div" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 84
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "chunr8",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 88
    }
  }, [".cc-chunr8{position:relative;flex-grow:0;flex-shrink:0;padding-bottom:2px;width:calc(100% / 3);text-align:right}", ".cc-chunr8::after{content:\"\";position:absolute;bottom:0;right:0;border-radius:5px;background:rgba(255,255,255,0.2);width:85%;height:6px}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-chunr8" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 371
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Group.displayName = "Group";
}

var PreventOverflow = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var _ref4$as = _ref4.as,
      C = _ref4$as === void 0 ? "div" : _ref4$as,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 94
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "of97x3",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 98
    }
  }, [".cc-of97x3{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-of97x3" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 196
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  PreventOverflow.displayName = "PreventOverflow";
}

var Name = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var _ref5$as = _ref5.as,
      C = _ref5$as === void 0 ? PreventOverflow : _ref5$as,
      props = (0, _objectWithoutProperties2["default"])(_ref5, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 93
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1az8t3a",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 97
    }
  }, [".cc-1az8t3a{color:#ffc99a}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1az8t3a" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 153
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Name.displayName = "Name";
}

var Value = /*#__PURE__*/_react["default"].forwardRef(function (_ref6, ref) {
  var _ref6$as = _ref6.as,
      C = _ref6$as === void 0 ? PreventOverflow : _ref6$as,
      props = (0, _objectWithoutProperties2["default"])(_ref6, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 94
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1byaalk",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 98
    }
  }, [".cc-1byaalk{font-size:20px;font-weight:bold}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1byaalk" + (props.className ? " " + props.className : ""),
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 172
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Value.displayName = "Value";
}